
import OImage from "@/components/base/image/OImage"
/** ATTENTION: Messe Image Spacing is dirty and only working for Messe-FRG right now */
export default {
    name: "OabatHeader",
    components: { OImage },
    props: {
        /** Text below logo - allows html */
        text: {
            type: String,
            default: "",
        },
        /** Different Logo from Oabat */
        img: {
            type: String,
            default: null,
        },
        /** Makes text white */
        messe: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        mainImage() {
            if (!this.img) {
                if (!this.messe) {
                    return require("@/assets/images/logos/logo-large.svg")
                }
                return require("@/assets/images/fair/logo.png")
            }
            return this.img
        },
    },
}
